(function () {

    var TURNSTILE_SCRIPT_URL = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';

    angular
        .module('app')
        .controller('LoginController', LoginController);

    LoginController.$inject = [
        'authService', 'loggerService', 'browserStorageService',
        '$location', '$stateParams', '$document', '$scope',
        '$timeout', '$state', '$mdDialog', 'utilService'
    ];

    function LoginController(authService, loggerService, browserStorageService, $location, $stateParams, $document, $scope, $timeout, $state, $mdDialog, utilService) {
        var vm = this;
        vm.authService = authService;

        $scope.busy = false;
        vm.useOrganizationLogin = authService.isOidcLoginEnabled();
        vm.useLocalPasswordLogin = authService.shouldUseLocalPreviewAuth();
        vm.usePasswordLogin = vm.useOrganizationLogin || vm.useLocalPasswordLogin;
        vm.allowTemporaryAccess = !vm.useOrganizationLogin;

        vm.loginstate = vm.usePasswordLogin ? 'localaccount' : 'login';
        vm.localLogin = {};
        readFocusFromUrl();
        continueAuthenticatedPostLogin();

        vm.sendEmail = function (ev) {
            $mdDialog.show({
                templateUrl : 'static/components/login/signup.tmpl.html',
                autoWrap : false,
                targetEvent : ev,
                controller : ["$scope", function ($scope) {
                    $scope.close = function() {
                        $mdDialog.hide();
                    };
                }]
            });
        };

        vm.deployment = $stateParams.DEPLOYMENT;

        vm.goToLogin = function () {
            vm.loginstate = vm.usePasswordLogin ? 'localaccount' : 'login';
            $scope.failure = null;
        };

        vm.loginWithOrganizationAccount = function () {
            if (vm.usePasswordLogin) {
                vm.loginstate = 'localaccount';
                $scope.failure = null;
                return;
            }
            $scope.busy = true;
            $scope.failure = null;
            return vm.authService.loginWithOrganizationAccount()
                .catch(function (err) {
                    if (authService.shouldUseLocalPreviewAuth()) {
                        loggerService.error('[ml4klogin] organization login unavailable in local preview, showing local password login', err);
                        vm.loginstate = 'localaccount';
                        return;
                    }
                    loggerService.error('[ml4klogin] organization account login failed', err);
                    $scope.failure = {
                        message : '登录服务暂时没有响应，请刷新页面后再试。',
                        status : err && err.status
                    };
                })
                .finally(function () {
                    $scope.busy = false;
                });
        };
        vm.login = vm.loginWithOrganizationAccount;

        vm.loginWithPassword = function (credentials) {
            $scope.busy = true;
            $scope.failure = null;

            if (!credentials || !credentials.username || !credentials.password) {
                $scope.failure = {
                    message : '请先填写用户名和密码。'
                };
                $scope.busy = false;
                return;
            }

            return authService.loginWithPassword(credentials.username, credentials.password)
                .then(function () {
                    return goAfterLogin();
                })
                .catch(function (err) {
                    loggerService.error('[ml4klogin] local password login failed', err);
                    $scope.failure = {
                        message : getErrorMessage(err.data),
                        status : err.status
                    };
                })
                .finally(function () {
                    $scope.busy = false;
                });
        };

        vm.startTryItNowSession = function (ev) {
            loggerService.debug('[ml4klogin] starting Try It Now');

            if (authService.isLocalPreviewHost()) {
                return startLocalPreviewSession();
            }

            if (!document.getElementById('tryitnow-turnstile-container')) {
                $scope.failure = {
                    message : 'Update required. Please refresh the page. If this persists, please clear your cache.'
                };
                return;
            }

            $scope.busy = true;
            let submitted = false;
            $scope.failure = null;

            return utilService.loadScript(TURNSTILE_SCRIPT_URL).then(function () {
                if (typeof turnstile === 'undefined' || !turnstile.render) {
                    throw new Error('Turnstile failed to load');
                }

                turnstile.render("#tryitnow-turnstile-container", {
                sitekey: TURNSTILE_SITE_KEY,
                'error-callback': function (err) {
                    loggerService.error('[ml4klogin] Failed to get turnstile token', err);
                    $scope.turnstileerror = err;
                    $scope.busy = false;
                },
                callback: function (token) {
                    if (!submitted) {
                        submitted = true;
                        authService.createSessionUser(token)
                            .then(function (/* newUser */) {
                                // can't rely on session users to log out,
                                //  so we clean up after the last session user
                                //  when the next one logs in
                                return attemptSessionUserCleanup();
                            })
                            .then(function () {
                                return goAfterLogin();
                            })
                            .catch(function (err) {
                                loggerService.error('[ml4klogin] session creation failed', err);

                                if (err && err.data && err.data.error && err.data.error.includes('turnstile')) {
                                    $scope.turnstileerror = err.data.error;
                                }
                                else {
                                    var errObj = err.data;

                                    $scope.failure = {
                                        message : getErrorMessage(errObj),
                                        status : err.status
                                    };
                                    $timeout(function () {
                                        var newItem = document.getElementById('sessionuserfailure');
                                        $document.duScrollToElementAnimated(angular.element(newItem));
                                    }, 0);
                                }
                            }).finally(function () {
                                $scope.busy = false;
                            });
                    }
                }
                });
            }).catch(function (err) {
                loggerService.error('[ml4klogin] Failed to load turnstile', err);
                $scope.failure = {
                    message : '人机验证暂时无法加载，请刷新页面后再试。'
                };
                $scope.busy = false;
            });
        };


        function startLocalPreviewSession() {
            $scope.busy = true;
            $scope.failure = null;
            return authService.createSessionUser('local-dev-turnstile')
                .then(function (/* newUser */) {
                    return attemptSessionUserCleanup();
                })
                .then(function () {
                    return goAfterLogin();
                })
                .catch(function (err) {
                    loggerService.error('[ml4klogin] local session creation failed', err);
                    var errObj = err.data;
                    $scope.failure = {
                        message : getErrorMessage(errObj),
                        status : err.status
                    };
                })
                .finally(function () {
                    $scope.busy = false;
                });
        }

        function goAfterLogin() {
            return authService.continueAfterLogin();
        }

        function continueAuthenticatedPostLogin() {
            if (!authService.isAuthenticated()) {
                return;
            }

            authService.continueAfterLogin()
                .catch(function (err) {
                    loggerService.error('[ml4klogin] failed to continue authenticated login', err);
                });
        }


        function attemptSessionUserCleanup () {
            return browserStorageService.deleteSessionUserProjects()
                .catch(function (err) {
                    loggerService.error('[ml4klogin] failed to cleanup session user resources', err);
                    return;
                });
        }


        function getErrorMessage (errObj) {
            if (errObj && errObj.error) {
                if (errObj.error === 'Class full') {
                    return '当前同时体验的人数太多了。“立即体验”有并发人数限制，请稍后再试，或使用账号登录。';
                }
                else {
                    return errObj.error;
                }
            }
            if (errObj && errObj.message) {
                return errObj.message;
            }
            return '未知错误';
        }

        function readFocusFromUrl() {
            var urlParms = $location.search();
            if (urlParms && urlParms.tab) {
                switch (urlParms.tab) {
                    case 'login':
                    case 'localaccount':
                    case 'reset':
                    case 'signup':
                    case 'teachersignup':
                    case 'newstudent':
                    case 'whyregister':
                        vm.loginstate = urlParms.tab;
                        break;
                }
            }
            if (vm.loginstate === 'localaccount' && !vm.usePasswordLogin) {
                vm.loginstate = 'login';
            }
        }
    }
}());
